import React, { useContext, useEffect } from "react";
import { useCartContext } from "~/assets/js/global/cartContext";
import useGroupOrder, { MEMBER_BUFFER } from "~/assets/js/global/useGroupOrder";
import i18next from "i18next";
import Headline from "../../../../components/Typography/Headline";
import { getSvgIcon } from "~/assets/js/Helpers/get-assets";
import {
    formatDateToHours,
    formatTimeslotEntryFromCart,
} from "~/assets/js/Helpers/timeslot-utils";
import CartItem from "../../../../components/CartItems/CartItem";
import Button from "~/assets/js/components/Button";
import { PAGES, CheckoutContext, ACTIONS } from "../../CheckoutProvider";
import { fetchStoreData } from "~/assets/js/Api/storeApi";
import FullPageLoader from "~/assets/js/components/Loaders/FullPageLoader";
import { subsFromDate } from "~/assets/js/Helpers/date-utils";

export default function MemberThankYou() {
    const { cart } = useCartContext();
    const { groupCartData, leaveParticipant, loading, isGroupOrder } =
        useGroupOrder();

    const { storePickupAddress } = fetchStoreData(groupCartData?.store_id);

    const bicycleIcon = getSvgIcon(`bicycle.svg`);
    const shopIcon = getSvgIcon("shop.svg");
    const checkoutContext = useContext(CheckoutContext);

    const continueEditingGroupOrder = () => {
        return checkoutContext.dispatch({
            type: ACTIONS.CHANGE_PAGE,
            payload: PAGES.CART,
        });
    };

    useEffect(() => {
        if (isGroupOrder === undefined) {
            return;
        }

        if (!isGroupOrder) {
            continueEditingGroupOrder();
        }
    }, [isGroupOrder]);

    if (!groupCartData) {
        return <FullPageLoader />;
    }

    const formatedDate = formatTimeslotEntryFromCart(
        groupCartData?.slot_begin,
        groupCartData?.slot_end
    );

    const location = ((groupCartData) => {
        const {
            shipping_address: shippingAddress,
            shipping_city: shippingCity,
            shipping_postcode: shippingPostCode,
            dispatch_type: dispatchType,
        } = groupCartData || {};

        if (dispatchType === "pickup") {
            return storePickupAddress;
        }

        return `${shippingAddress}, ${shippingPostCode} ${shippingCity}`;
    })(groupCartData);

    const orderTill = formatDateToHours(
        subsFromDate({
            date: groupCartData?.slot_valid_until,
            ...MEMBER_BUFFER,
        })
    );

    return (
        <div className="member-thank-you">
            <div>
                <h3 className="member-thank-you__owner">
                    {i18next.t("groupOrderThankYou.bannerText", {
                        name: groupCartData?.owner_name,
                    })}
                </h3>
                <Headline>{i18next.t("groupOrderThankYou.title")}</Headline>
                <p className="member-thank-you__description">
                    {i18next.t("groupOrderThankYou.description")}
                </p>
                <br />
                <p className="member-thank-you__text">
                    <img
                        src={
                            groupCartData.dispatch_type === "pickup"
                                ? shopIcon
                                : bicycleIcon
                        }
                        alt="dispatchType"
                        className="member-thank-you__icon"
                    />
                    <span>
                        {i18next.t(
                            `joinGroupOrder.${groupCartData?.dispatch_type}`
                        )}
                    </span>
                </p>
                <p className="member-thank-you__text">
                    <span className="member-thank-you__iconText">
                        {i18next.t(`joinGroupOrder.location`)}
                    </span>

                    <span>{location}</span>
                </p>
                <p className="member-thank-you__text">
                    <span className="member-thank-you__iconText">
                        {i18next.t(`joinGroupOrder.time`)}
                    </span>
                    <span>{formatedDate}</span>
                </p>
                <p className="member-thank-you__text">
                    <span className="member-thank-you__iconText">
                        {i18next.t(`joinGroupOrder.creditCard`)}
                    </span>
                    <span>
                        {i18next.t("joinGroupOrder.payedBy", {
                            name: groupCartData?.owner_name,
                            till: orderTill,
                        })}
                    </span>
                </p>
                <Headline className={"member-thank-you__produts-header"}>
                    {i18next.t("groupOrderThankYou.products")}
                </Headline>
                {cart.items &&
                    cart?.items.map((cartItem, index) => (
                        <CartItem
                            key={cartItem.product_id}
                            cartItem={cartItem}
                            inCartPosition={index}
                            items={cart?.items}
                            readOnly
                        />
                    ))}
                <Button
                    size="LG"
                    variant="danger"
                    label={i18next.t("groupOrderThankYou.cancelButton")}
                    onClick={leaveParticipant}
                    disabled={loading}
                />
            </div>
        </div>
    );
}
